import React from 'react';
import MaterialFormControl from '@mui/material/FormControl';
import type {FormControlProps as MaterialFormControlProps} from '@mui/material/FormControl';

export interface FormControlProps extends MaterialFormControlProps {
    /**
     * Used to replace root node with different
     * component.
     */
    component?: React.ElementType<any>;
}

export const FormControl = React.forwardRef<HTMLDivElement, FormControlProps>(({
    children,
    ...props
}, ref) => (
    <MaterialFormControl
        ref={ref}
        {...props}
    >
        {children}
    </MaterialFormControl>
));

FormControl.displayName = 'FormControl';
